import React from 'react'
import { useWishlist } from '../../context/WishlistContext'
import { Link, useNavigate } from 'react-router-dom';
import Navbar from '../Navbar';
import Navbar2 from '../Navbar2';
import './WishlistScreen.css'
import { useCart } from '../../context/CartContext';
import Footer from '../Footer/Footer';

function WishlistScreen() {
    const { wishlistItems, removeFromWishlist } = useWishlist();
    const { addToCart } = useCart();
    const navigate = useNavigate();

    const handleAddToCart = (product) => {
        addToCart(product);
        // Optional: Show toast notification
        // alert(`${product.title} added to cart!`);
    };

    return (
        <>
            <Navbar />
            <div className="sticky-navbar">
                <Navbar2 />
            </div>

            <div className="wishlist-screen">
                <div className="container py-4">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h2 className="mb-0">Your Wishlist</h2>
                        <span className="badge bg-primary">
                            {wishlistItems.length} {wishlistItems.length === 1 ? 'item' : 'items'}
                        </span>
                    </div>

                    {wishlistItems.length === 0 ? (
                        <div className="empty-wishlist text-center py-5">
                            <div className="empty-icon mb-3">
                                <i className="bi bi-heart" style={{ fontSize: '3rem', color: '#dc3545' }}></i>
                            </div>
                            <h4 className="mb-3">Your wishlist is empty</h4>
                            <p className="text-muted mb-4">Save your favorite items here for later</p>
                            <Link to='/' className='btn btn-primary px-4'>
                                <i className="bi bi-arrow-left me-2"></i>
                                Continue Shopping
                            </Link>
                        </div>
                    ) : (
                        <div className="row g-4">
                            {wishlistItems.map(item => (
                                <div key={item._id} className="col-lg-3 col-md-4 col-sm-6">
                                    <div className="card h-100 wishlist-card">
                                        <div
                                            className="wishlist-img-container"
                                            onClick={() => navigate(`/bboo/${item._id}`)}
                                        >
                                            <img
                                                src={item.image}
                                                alt={item.title}
                                                className="card-img-top"
                                            />
                                            <div className="wishlist-overlay">
                                                <button
                                                    className="btn btn-sm btn-outline-light quick-view-btn"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        navigate(`/bboo/${item._id}`);
                                                    }}
                                                >
                                                    Quick View
                                                </button>
                                            </div>
                                        </div>

                                        <div className="card-body">
                                            <h5 className="card-title" title={item.title}>
                                                {item.title.length > 30
                                                    ? `${item.title.substring(0, 30)}...`
                                                    : item.title}
                                            </h5>
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <span className="price">₹{item.price}</span>
                                                <span className="rating">
                                                    <i className="bi bi-star-fill text-warning"></i> 4.5
                                                </span>
                                            </div>

                                            <div className="d-grid gap-2">
                                                <button
                                                    className="btn btn-outline-danger btn-sm"
                                                    onClick={() => removeFromWishlist(item._id)}
                                                >
                                                    <i className="bi bi-trash me-1"></i> Remove
                                                </button>
                                                <button
                                                    className="btn btn-primary btn-sm"
                                                    onClick={() => {
                                                        if (item.quantity <= 0) {
                                                            alert('This product is out of stock');
                                                        } else {
                                                            handleAddToCart(item);
                                                        }
                                                    }}
                                                    disabled={item.quantity <= 0}
                                                >
                                                    <i className="bi bi-cart-plus me-1"></i>
                                                    {item.quantity <= 0 ? 'Out of Stock' : 'Add to Cart'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
}

export default WishlistScreen